var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#5AA771"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 15.8334H9.16683C8.94582 15.8334 8.73385 15.7456 8.57757 15.5893C8.42129 15.4331 8.3335 15.2211 8.3335 15.0001C8.3335 14.7791 8.42129 14.5671 8.57757 14.4108C8.73385 14.2545 8.94582 14.1667 9.16683 14.1667H20.8335C21.0545 14.1667 21.2665 14.2545 21.4228 14.4108C21.579 14.5671 21.6668 14.7791 21.6668 15.0001C21.6668 15.2211 21.579 15.4331 21.4228 15.5893C21.2665 15.7456 21.0545 15.8334 20.8335 15.8334Z",
    fill: "#5AA771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.933b9c9f2c73b2777f52a960e9a01472.svg";
export { ForwardRef as ReactComponent };